export const NO_AUTH = "x-no-msal";
export const IF_MATCH = "If-Match";
export const X_TENANT = "X-Tenant";
export const TRACE_ID = "ProsWebApp"; //appContext.appInsights?.context.telemetryTrace.traceID;
export const CONTENT_TYPE_HEADER = "Content-Type";
export const ERROR_TYPE = "x-error-type";
